import { inject, Injectable } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { HttpClient, HttpParams } from '@angular/common/http'
import { eps } from './url.service'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'

@Injectable({ providedIn: 'root' })
export class NotificationService {
  constructor(private toastr: ToastrService) {}
  private apiEndpoint = environment.apiBaseUrl

  private http = inject(HttpClient)
  private api = eps.notifications

  list(
    userId: string,
    search: string,
    page: number,
    limit: number,
    fromDate?: string,
    toDate?: string
  ): Observable<{ totalCount: number; notifications: any[] }> {
    let params = new HttpParams()
    params = params.set('userId', userId)
    // params = params.set('title', search)
    params = params.set('page', page)
    params = params.set('limit', limit)
    if (search) {
      params = params.set('title', search)
    }

    if (fromDate && toDate) {
      params = params.set('fromDate', fromDate)
      params = params.set('toDate', toDate)
    }
    return this.http.get<{ totalCount: number; notifications: any[] }>(this.api.notificationsApi, {
      params
    })
  }

  markAsRead(id: string) {
    return this.http.patch(`${this.apiEndpoint}/notifications/${id}`, { isRead: true })
  }
}
